var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3666",
    d: "M0-682.665H100v100H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3664",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3670",
    transform: "translate(13.236 5.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3672",
    d: "M-254.125-528.586h-43.614v-72.65a4.742,4.742,0,0,1,3.231-4.495l40.383-13.574Z",
    transform: "translate(297.739 619.305)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3674",
    transform: "translate(56.85 47.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3676",
    d: "M-143.026-233.692v9.113h-24.547V-273.8h27.084a3.247,3.247,0,0,1,3.248,3.248V-244.5",
    transform: "translate(167.573 273.799)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3678",
    transform: "translate(56.85 87.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3680",
    d: "M0-53.1H39.483a2.2,2.2,0,0,0,2.2-2.2v-6.911H0Z",
    transform: "translate(0 62.211)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3682",
    transform: "translate(81.396 76.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3684",
    d: "M-47.521,0h.827a8.156,8.156,0,0,1,8.156,8.156v3H-55.677v-3A8.156,8.156,0,0,1-47.521,0Z",
    transform: "translate(55.677)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3686",
    transform: "translate(1.465 87.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3688",
    d: "M-12.832-53.1h9.568v-9.113H-15.035V-55.3A2.2,2.2,0,0,0-12.832-53.1Z",
    transform: "translate(15.035 62.211)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3690",
    transform: "translate(1.465 76.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3692",
    d: "M-61.874,0h1.152V11.157H-72.493v-.538A10.619,10.619,0,0,1-61.874,0Z",
    transform: "translate(72.493)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3694",
    transform: "translate(56.85 5.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3696",
    d: "M-88.369-241.79h-15.166v-41.5l13.72,13.262a4.742,4.742,0,0,1,1.446,3.409V-248.7",
    transform: "translate(103.536 283.287)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3698",
    transform: "translate(23.904 3.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3700",
    d: "M0-75.382v-9.893A3.045,3.045,0,0,1,3.047-88.32h.309A3.045,3.045,0,0,1,6.4-85.275v7.74",
    transform: "translate(0 88.32)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3702",
    transform: "translate(23.904 16.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3704",
    d: "M-191.961,0l-32.945,11.074",
    transform: "translate(224.906)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3706",
    transform: "translate(23.904 27.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3708",
    d: "M-191.961,0l-32.945,11.074",
    transform: "translate(224.906)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3710",
    transform: "translate(23.904 37.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3712",
    d: "M-191.961,0l-32.945,11.074",
    transform: "translate(224.906)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3714",
    transform: "translate(23.904 48.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3716",
    d: "M-191.961,0l-32.945,11.074",
    transform: "translate(224.906)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3718",
    transform: "translate(23.904 68.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3720",
    d: "M-31.689,0l-5.439,1.828",
    transform: "translate(37.128)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3722",
    transform: "translate(35.903 58.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3724",
    d: "M-122.049,0-143,7.041",
    transform: "translate(142.996)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3726",
    transform: "translate(23.905 77.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3728",
    d: "M-101.154-107.123h-17.361v-12.444a2.15,2.15,0,0,1,1.572-2.071l13.634-3.806a1.7,1.7,0,0,1,2.154,1.635Z",
    transform: "translate(118.514 125.508)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3730",
    transform: "translate(63.724 53.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3732",
    d: "M-89.561-32.263h-14.365a1.006,1.006,0,0,1-1.005-1.005v-3.526a1.006,1.006,0,0,1,1.005-1.006h14.365a1.006,1.006,0,0,1,1.006,1.006v3.526A1.006,1.006,0,0,1-89.561-32.263Z",
    transform: "translate(104.932 37.8)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3734",
    transform: "translate(63.724 64.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3736",
    d: "M-89.561-32.263h-14.365a1.006,1.006,0,0,1-1.005-1.006v-3.526a1.006,1.006,0,0,1,1.005-1.005h14.365a1.006,1.006,0,0,1,1.006,1.005v3.526A1.006,1.006,0,0,1-89.561-32.263Z",
    transform: "translate(104.932 37.8)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3738",
    transform: "translate(63.724 76.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3740",
    d: "M-33.544-32.263H-38.3A1.006,1.006,0,0,1-39.3-33.268v-3.526A1.006,1.006,0,0,1-38.3-37.8h4.752a1.006,1.006,0,0,1,1.006,1.006v3.526A1.006,1.006,0,0,1-33.544-32.263Z",
    transform: "translate(39.301 37.8)",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3742",
    transform: "translate(32.585 79.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3744",
    d: "M0,0V16.5",
    fill: "rgba(0,0,0,0)",
    stroke: "#005795",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyMaster);
export default __webpack_public_path__ + "static/media/companyMaster.a2e0708ae2bd61647db2f68d96c92b64.svg";
export { ForwardRef as ReactComponent };